/**
 * Slug-Map für sprachspezifische URLs.
 *
 * Die meisten Routen sind sprachneutral (/login, /dashboard, /settings) und
 * brauchen kein Mapping — dort genügt das /en-Präfix. SEO-Landingpages haben
 * dagegen pro Sprache EIGENE Keyword-Slugs (deutsche Slugs würden auf
 * Englisch nicht ranken).
 *
 * Format: sprachneutraler Key (= deutscher Slug ohne Präfix) → { de, en }.
 * Englische Slugs werden in Phase 3 (Landingpage-Lokalisierung mit
 * Keyword-Research) befüllt; bis dahin gilt: en === null bedeutet
 * "keine englische Version" → Switcher/hreflang fallen auf '/' bzw. '/en' zurück.
 */

export const SLUG_MAP = {
  // Kern-Landingpages (en-Slugs: Phase 3)
  '/ebook-verkaufen': { en: '/sell-ebooks-online' },
  '/digitale-produkte-verkaufen': { en: '/sell-digital-products' },
  '/kursplattform': { en: null },
  '/digistore24-alternative': { en: null },
  '/elopage-alternative': { en: null },
  '/gumroad-alternative': { en: '/gumroad-alternative' },
  '/copecart-alternative': { en: null },
  '/stan-store-alternative-deutsch': { en: null },
  '/pdf-verkaufen': { en: null },
  '/notion-templates-verkaufen': { en: '/sell-notion-templates' },
  '/affiliate-plattform': { en: null },
  '/creator-werben': { en: '/refer-creators' },
  '/empfehlungsprogramm': { en: '/creator-referral-program' },
  '/passives-einkommen-online': { en: '/passive-income-for-creators' },
  '/affiliate-ohne-eigene-produkte': { en: '/affiliate-without-own-products' },
  '/ki-produkte-verkaufen': { en: null },
  '/prompts-verkaufen': { en: '/sell-ai-prompts' },
  '/ki-software-verkaufen': { en: null },
  '/mcp-server-verkaufen': { en: '/sell-mcp-servers' },
  '/promptbase-alternative-deutsch': { en: null },
  '/mit-ki-geld-verdienen': { en: null },
  '/ebook-verkaufen-ohne-webseite': { en: null },
  '/kurs-verkaufen-ohne-webseite': { en: null },
  '/pdf-verkaufen-ohne-webseite': { en: null },
  '/canva-templates-verkaufen': { en: null },
  '/excel-templates-verkaufen': { en: null },
  '/chatgpt-prompts-verkaufen': { en: null },
  '/midjourney-prompts-verkaufen': { en: null },
  '/custom-gpt-verkaufen': { en: null },
  '/n8n-workflows-verkaufen': { en: null },
  '/mcp-fuer-ecommerce': { en: null },
  '/mit-ki-produkte-erstellen-und-verkaufen': { en: null },

  // Hinweis: Hilfe, Melden und die Rechts-/Policy-Seiten (Impressum, Datenschutz,
  // AGB, Widerruf, Inhaltsrichtlinien) sind zweisprachig unter demselben,
  // sprachneutralen Slug erreichbar (z.B. /impressum ↔ /en/impressum). Sie
  // brauchen daher KEINEN Eintrag hier — translatePath() ergänzt für neutrale
  // Routen automatisch das /en-Präfix.
};

/**
 * Übersetzt einen sprachneutralen (deutschen) Pfad in die Zielsprache.
 * Gibt den vollständigen Pfad inkl. Präfix zurück.
 * Hat eine Seite (noch) keine Entsprechung, wird auf die jeweilige
 * Startseite zurückgefallen.
 */
export function translatePath(neutralPath, targetLang) {
  if (targetLang === 'de') {
    return neutralPath;
  }
  const entry = SLUG_MAP[neutralPath];
  if (entry !== undefined) {
    return entry.en ? `/en${entry.en}` : '/en';
  }
  // Sprachneutrale Route: nur Präfix ergänzen
  return neutralPath === '/' ? '/en' : `/en${neutralPath}`;
}

/**
 * Ermittelt für einen englischen Pfad (ohne /en-Präfix) den deutschen Slug.
 */
export function englishToGermanPath(enPath) {
  for (const [dePath, entry] of Object.entries(SLUG_MAP)) {
    if (entry.en === enPath) return dePath;
  }
  return enPath;
}
